import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';

import {
  displayHeadingTrailingRuleContainerSx,
  displayHeadingTrailingRuleLineSx,
  displayHeadingTrailingRuleTextSx,
} from 'src/common/styles/displayHeadingRuleStyles';

type HeadingComponent = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
type HeadingVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface Props {
  variant: HeadingVariant;
  component: HeadingComponent;
  sx?: SxProps<Theme>;
  typographySx?: SxProps<Theme>;
  children: ReactNode;
}

/** Section heading with a trailing line from the end of the text to the container edge. */
export default function DisplayHeadingWithRule({
  variant,
  component,
  sx,
  typographySx,
  children,
}: Props) {
  return (
    <Box
      component={component}
      sx={[displayHeadingTrailingRuleContainerSx, ...(sx ? [sx] : [])] as SxProps<Theme>}
    >
      <Typography
        variant={variant}
        component="span"
        sx={[displayHeadingTrailingRuleTextSx, ...(typographySx ? [typographySx] : [])] as SxProps<Theme>}
      >
        {children}
      </Typography>
      <Box component="span" aria-hidden sx={displayHeadingTrailingRuleLineSx} />
    </Box>
  );
}
